import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, ModalController } from 'ionic-angular';
import { GN } from '../../../../gn';
import { DIC } from '../../../dic';
import { SearchemployeePage } from './searchemployee';

/**
 * Generated class for the ChoosedriverbankPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-choosedriverbank',
  templateUrl: 'choosedriverbank.html',
})
export class ChoosedriverbankPage {
  selectedDriver = '--- Избери вработен ---';
  selectedDriverIds = - 1
  DriversData = []
  selectedWeapon = '-- Избери оружје --'
  selectedWeaponId = -1
  selectedPosition = '-- Избери позиција --'
  selectedPositionId = -1
  WeaponsData = []
  PositionData = []
  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public alertCtrl: AlertController, public toastCtrl: ToastController, public modalCtrl: ModalController) {

  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad ChoosedriverbankPage');
    this.getAllDrivers()
    this.loadPositions()
  }
  getAllDrivers() {
    var _that = this
    // _that.DriversData.push({id: 0, name: '-- '+this.dic.l["ChooseDriver"]+' --'})
    var selDriver = this.navParams.get('selDriver')
    this.gn._Post('/api/gn/getalldrivers', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      for (var i = 0; i < _data.length; i++) {
        if (selDriver.filter(e => e.DriverId === _data[i].id).length > 0) { } else {
          _that.DriversData.push({ id: _data[i].id, name: _data[i].fullname })
        }
      }
      // console.log(_data)
    })
  }


  selectDriver(_ev) {
    var _that = this
    let alert = this.alertCtrl.create();
    alert.setTitle(this.dic.l["ChooseDriver"]);
    for (var i = 0; i < this.DriversData.length; i++) {
      var ch = false
      if (this.DriversData[i].id + '' == this.selectedDriverIds + '') {
        ch = true
      }
      alert.addInput({
        type: 'radio',
        label: this.DriversData[i].name,
        value: this.DriversData[i].id,
        checked: ch
      });
    }

    alert.addButton(this.dic.l['cancel']);
    alert.addButton({
      text: this.dic.l['ok'],
      handler: data => {
        // console.log('Checkbox data:', data);
        _that.selectedDriverIds = data
        for (var i = 0; i < _that.DriversData.length; i++) {
          if (_that.DriversData[i].id + '' == data + '') {
            _that.selectedDriver = _that.DriversData[i].name
          }
        }
        _that.selectedWeapon = '-- Избери оружје --'
        _that.selectedWeaponId = -1
        _that.WeaponsData = []
      }

    });
    alert.present();
  }

  openDriverSelect() {
    var _that = this
    // _that.selectedDriver = ''
    let modal = this.modalCtrl.create(SearchemployeePage, {
      gr: _that.DriversData, didd: _that.selectedDriverIds, cb: function (_did, _dName) {
        _that.selectedDriverIds = _did
        _that.selectedDriver = _dName
        _that.selectedWeaponDriverSelect()
        var ekipa = _that.navParams.get('selDriver')

        //ako nema rakovoditel
        if (ekipa.filter(ek => (ek.PositionId === 4)).length == 0) {
          _that.selectedPositionId = 4
          _that.selectedPosition = _that.PositionData[3].name
        } else {
          //ako nema manipulant
          if (ekipa.filter(ek => (ek.PositionId === 1)).length == 0) {
            _that.selectedPositionId = 1
            _that.selectedPosition = _that.PositionData[0].name
          } else {
            //ako nema obezbeduvac
            if (ekipa.filter(ek => (ek.PositionId === 2)).length == 0) {
              _that.selectedPositionId = 2
              _that.selectedPosition = _that.PositionData[1].name
            } else {
              //ako ima se drugo, dodadi rabotnik od trezor
              _that.selectedPositionId = 3
              _that.selectedPosition = _that.PositionData[2].name
            }
          }
        }
      }
    },
      { cssClass: "modal-fullscreen3" }
    );
    modal.present();
  }

  selectedWeaponDriverSelect() {
    var _that = this
    // if (this.selectedWeaponId == -1) {
    if (this.selectedDriverIds > -1) {
      this.gn._Post('/api/gn/getweapon', { did: this.gn.crypt(_that.selectedDriverIds) }, function (_data) {
        _that.WeaponsData = _data
        // debugger
        for (let i = 0; i < _data.length; i++) {
          _that.selectedWeapon = _that.WeaponsData[i].name
          _that.selectedWeaponId = _that.WeaponsData[i].id
        }
        if (_data.length == 0) {
          // console.log('vlagas li tuka')
          _that.selectedWeapon = '-- Избери оружје --'
          _that.selectedWeaponId = -1
        }
      })
    }
  }


  selectWeapon(_ev) {
    var _that = this
    var _checked = false;
    if (this.selectedDriverIds > -1) {
      this.gn._Post('/api/gn/getweapon', { did: this.gn.crypt(_that.selectedDriverIds) }, function (_data) {
        _that.WeaponsData = _data
        let alert = _that.alertCtrl.create();
        alert.setTitle('Избери оружје');
        for (var i = 0; i < _data.length; i++) {
          if (_that.selectedWeaponId == _data[i].id) { _checked = true }
          else {
            _checked = false
          }


          alert.addInput({
            type: 'radio',
            label: _data[i].name,
            value: _data[i].id,
            checked: _checked
          });
        }

        alert.addButton(_that.dic.l['cancel']);
        alert.addButton({
          text: _that.dic.l['ok'],
          handler: data => {
            // selectedWeapon = data
            _that.selectedWeaponId = data
            for (var i = 0; i < _that.WeaponsData.length; i++) {
              if (_that.WeaponsData[i].id == data) {
                _that.selectedWeapon = _that.WeaponsData[i].name
              }
            }
          }
        });
        if (_that.WeaponsData.length > 0)
          alert.present();
      })
    }

  }
  loadPositions() {
    var _that = this
    this.gn._Post('/api/gn/getbankpositios', {}, function (_data) {
      _that.PositionData = _data
      // console.log(_data, 'daj da vidam data')
    })
  }

  selectPosition(_ev) {
    var _that = this
    let alert = _that.alertCtrl.create();
    alert.setTitle('Избери оружје');
    for (var i = 0; i < _that.PositionData.length; i++) {
      var _checked = false
      if (_that.selectedPositionId == _that.PositionData[i].id) { _checked = true }
      else {
        _checked = false
      }
      alert.addInput({
        type: 'radio',
        label: _that.PositionData[i].name,
        value: _that.PositionData[i].id,
        checked: _checked
      });
    }
    alert.addButton(_that.dic.l['cancel']);
    alert.addButton({
      text: _that.dic.l['ok'],
      handler: data => {
        // selectedWeapon = data
        _that.selectedPositionId = data
        for (var i = 0; i < _that.PositionData.length; i++) {
          if (_that.PositionData[i].id == data) {
            _that.selectedPosition = _that.PositionData[i].name
          }
        }
      }
    });
    alert.present();
  }


  Save() {
    if (this.selectedDriverIds == -1) {
      const toast = this.toastCtrl.create({ message: 'Изберете вработен !', duration: 3000, position: 'top' });
      toast.present();
      return
    }
    // if (this.selectedWeaponId==-1){
    //   const toast = this.toastCtrl.create({ message: 'Изберете оружје !', duration: 3000, position: 'top' });
    //   toast.present();
    //   return
    // }
    if (this.selectedPositionId == -1) {
      const toast = this.toastCtrl.create({ message: 'Изберете позиција !', duration: 3000, position: 'top' });
      toast.present();
      return
    }
    var cb = this.navParams.get('cb')
    if (cb != null) {
      if (this.selectedWeaponId == -1) {
        this.selectedWeapon = ''
      }
      cb(this.selectedDriver, this.selectedDriverIds, this.selectedWeapon, this.selectedWeaponId, this.selectedPosition, this.selectedPositionId)
      this.navCtrl.pop()
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/routing/routebank/choosedriverbank/choosedriverbank.ts